import React, { useEffect, useState } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'

const VerifyEmail = ({ onVerify }) => {
    const [searchParams] = useSearchParams()
    const navigate = useNavigate()
    const [status, setStatus] = useState('Verifying your email...')
    const token = searchParams.get('token')

    useEffect(() => {
        if (!token) {
            setStatus('Verification token is missing.')
            return
        }
        ;(async () => {
            try {
                const response = await fetch(
                    `${import.meta.env.VITE_BACKEND_URL}/auth/verify-email?token=${token}`
                )
                if (!response.ok) {
                    let data = {}
                    try {
                        data = await response.json()
                    } catch {}
                    setStatus(data.error || 'Verification failed.')
                    return
                }
                const data = await response.json()
                localStorage.setItem('token', data.token)
                onVerify?.()
                navigate('/user-dashboard')
            } catch (error) {
                setStatus('Server error. Please try again later.')
            }
        })()
    }, [token, navigate, onVerify])

    return (
        <div className="max-w-md mx-auto bg-bg-light p-8 rounded-lg shadow-md border border-gray-200 mt-10">
            <h2 className="text-3xl font-bold text-center mb-6">{status}</h2>
        </div>
    )
}

export default VerifyEmail